namespace distill.datasets.views.index {

    class InitArgs {
        datasetsIndex: string = appn.emptyString;
        createUrl: string = appn.emptyString;
    }

    let _initArgs: InitArgs;
    let _dataTable: any;

    export function init(args: InitArgs): void {
        _initArgs = args;
        appn.folderFilter.init(_initArgs.datasetsIndex);

        createDataTable();
        addEvents();
    }

    function addEvents(): void {
        $('#create').off('click').on('click', function() {
            const folderId = appn.folderFilter.selectedFolderId;
            appn.iframe.openModal({ url: folderId ? `${_initArgs.createUrl}?folderId=${folderId}` : _initArgs.createUrl });
        });

        $('#confirmBulkDeleteBtn').off('click').on('click', function() {
            const formElement = document.getElementById('appnFormManageDatasets') as HTMLFormElement;
            if (formElement) {
                formElement.submit();
            }
        });
    }

    function createDataTable(): void {
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: 'Datasets/DataTable',
            fnServerData: function (data: any) {
                data.push(
                    appn.dataTable.getStateOrDefault('sCustom_0', ''),
                    { name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value }
                );
            },
            aaSorting: [[1, 'asc']],
            autoWidth: false,
            aoColumns: [
                { bSortable: false, sWidth: '3%' },
                { bSortable: true, sWidth: '30%' },
                { bSortable: true, sWidth: '17%' },
                { bSortable: true, sWidth: '10%' },
                { bSortable: true, sWidth: '15%' }
            ],
            fnInitComplete: function() {
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                    { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                ], appn.requestUser.isUserOrHigher, true);

                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                $('#organiseBtn').click(function() {
                    appn.folderFilter.showDialog($(this), 'Datasets');
                });
                
                $('#manageBtn').on('click', function (this: HTMLElement, e: Event) {
                    e.preventDefault();
                    if ($(this as any).css('opacity') === '1') {
                        const $selectedItems = $('.selectRow:checked');

                        let datasets = appn.emptyString;
                        $selectedItems.each(function (index: number, selected: HTMLElement) {
                            const datasetId = $(selected).attr('id');
                            datasets += `${datasetId},`;
                        });

                        $('#datasetsToManage').val(datasets);
                        $('#manageDatasetsDialog').modal('show');
                    }
                });

                appn.dataTable.addSearchPlaceholder(T('Filter results where Dataset <b>Title, External Id or Status</b> contains a keyword typed in here.'));

                appn.saveMeState.init(function(): any {
                    _dataTable.fnDraw(false);
                },
                    function(): any {
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');
            }
        });
    }
}
